import PageBanner from "../components/PageBanner";
import Seo from "../components/Seo";
import { Reveal, SectionLabel, OmMark } from "../components/Motion";
import { useApp } from "../AppContext";
import { C, PARAMPARA, IMAGES, PARAMPARA_IMG, AUDUMBAR_TREE_IMG } from "../content";

export default function Heritage() {
  const { t, lang } = useApp();
  const L = (o) => o[lang] ?? o.en;
  return (
    <div>
      <Seo title="Audumbar & the Datta Parampara" description="Shri Kshetra Audumbar and the Datta lineage: Shri Narasimha Saraswati's Chaturmas, the sacred Audumbar tree, Nirguna Padukas, and the Audumbar Guru Parampara." />
      <PageBanner label="Audumbar" titleObj={C.audumbar} subObj={C.audumbar} image={IMAGES.ghatWalkway} />

      <section className="py-16 lg:py-24 max-w-[1100px] mx-auto px-4 lg:px-8">
        <div className="space-y-20">
          {C.audumbar.chapters.map((ch) => (
            <Reveal key={ch.n}>
              <div className="relative" data-testid={`heritage-chapter-${ch.n}`}>
                <span className="absolute -top-10 -left-2 lg:-left-8 font-serif-head text-8xl lg:text-9xl text-saffron-500/15 -z-0 select-none">{ch.n}</span>
                <div className="relative z-10 border-l-2 border-saffron-500/40 pl-6 lg:pl-10">
                  <h2 className="font-serif-head text-3xl lg:text-5xl text-earth-900 font-bold">{t(ch, "t")}</h2>
                  <p className="mt-4 text-earth-800/85 text-lg leading-relaxed">{t(ch, "b")}</p>
                  {ch.n === "03" && (
                    <div className="mt-8 rounded-3xl overflow-hidden border border-earth-900/10 shadow-[0_20px_50px_rgba(59,34,19,0.14)]" data-testid="audumbar-tree-image">
                      <img src={AUDUMBAR_TREE_IMG} alt="The sacred Audumbar tree in the Math courtyard" loading="lazy" className="w-full object-cover" />
                      <div className="bg-earth-900 text-sand-100 text-center py-2.5 font-serif-head text-lg">{lang === "mr" ? "पवित्र औदुंबर वृक्ष — मठ प्रांगण" : "The sacred Audumbar tree — Math courtyard"}</div>
                    </div>
                  )}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      {/* Guru Parampara */}
      <section className="py-16 lg:py-24 bg-sand-100" data-testid="guru-parampara">
        <div className="max-w-[900px] mx-auto px-4 lg:px-8">
          <Reveal><SectionLabel>{lang === "mr" ? "गुरुपरंपरा" : "Lineage"}</SectionLabel>
            <h2 className="font-serif-head text-4xl lg:text-5xl text-earth-900 font-bold mb-10">{lang === "mr" ? "औदुंबर गुरुपरंपरा" : "The Audumbar Guru Parampara"}</h2>
          </Reveal>
          <Reveal delay={0.05}>
            <div className="mx-auto max-w-[300px] mb-12 rounded-3xl overflow-hidden border border-earth-900/10 shadow-[0_20px_50px_rgba(59,34,19,0.16)]" data-testid="parampara-image">
              <img src={PARAMPARA_IMG} alt="Shri Datta Guru, Shri Narayananand Tirth Swami and Brahmashri Vyankatraman Dixit Guruji" loading="lazy" className="w-full object-cover" />
            </div>
          </Reveal>
          <div className="relative pl-8 border-l-2 border-ochre-500/40 space-y-8">
            {PARAMPARA.map((g, i) => (
              <Reveal key={i} delay={i * 0.08}>
                <div className="relative">
                  <span className="absolute -left-[41px] top-1 w-5 h-5 rounded-full bg-saffron-500 border-4 border-sand-100 flex items-center justify-center" />
                  <div className="flex items-center gap-3">
                    <OmMark className="w-6 h-6 text-deepred-700" />
                    <span className="font-serif-head text-2xl lg:text-3xl text-earth-900">{L(g)}</span>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
